export default {
  data() {
    return {
      /**
       * Current view mode.
       */
      viewMode: 'main',

      /**
       * The list of used view modes and their settings.
       * This should be overridden!
       */
      viewModes: [
        {'mode': 'main', 'title': 'Main', 'icon': 'fa-info'}
      ],
    }
  },

  methods: {

    /**
     * Checks if the current view mode matches the given mode.
     *
     * @param {string} mode - The mode to compare with the current mode.
     * @return {boolean} Returns true if the current mode matches the given mode, otherwise returns false.
     */
    mode(mode) {
      return this.viewMode === mode;
    },

    /**
     * Sets the current view mode.
     *
     * @param {string} mode - The mode to set.
     */
    setMode(mode) {
      this.onBeforeModeSet?.(mode);
      this.viewMode = mode;
      this.onAfterModeSet?.(mode);
    },

    /**
     * Returns the settings for the given view mode.
     * @param {string} mode - The mode to retrieve settings for.
     * @return {object|boolean} - The settings object for the specified mode if found, or false otherwise.
     */
    modeSettings(mode) {
      const settings = this.viewModes.find(vm => vm.mode === mode);
      return (settings === undefined) ? false : settings;
    },

  },

  computed: {

    /**
     * Returns the title of the view mode.
     *
     * @return {string} The title of the view mode, or an empty string if no title is found.
     */
    viewModeTitle() {
      const settings = this.modeSettings(this.viewMode);
      return (settings === false) ? '' : (settings.title || '');
    },

    /**
     * Returns the icon associated with the current view mode.
     *
     * @returns {string} The icon associated with the current view mode, or an empty string if not found.
     */
    viewModeIcon() {
      const settings = this.modeSettings(this.viewMode);
      return (settings === false) ? '' : (settings.icon || '');
    },

  }
}
